'use client';

import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { getChild } from '@sola/proxy-sdk/children.ts';
import { MY_QUERY_KEYS } from '../constants.ts';
type ChildDetailsData = NonNullable<Awaited<ReturnType<typeof getChild>>>;

/**
 * Hook to fetch and cache child details by child ID.
 */
export const useChildDetails = childId => {
  const $ = _c(7);
  let t0;
  let t1;
  if ($[0] !== childId) {
    t0 = [MY_QUERY_KEYS.childDetails, childId];
    t1 = async () => {
      if (!childId) {
        throw new Error("Missing child id.");
      }
      const childDetails = await getChild(childId);
      if (!childDetails) {
        throw new Error("Empty child details response.");
      }
      return childDetails;
    };
    $[0] = childId;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  const t2 = !!childId;
  let t3;
  if ($[3] !== t0 || $[4] !== t1 || $[5] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      enabled: t2,
      refetchOnWindowFocus: false,
      staleTime: Infinity
    };
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return useQuery(t3);
};